export default __webpack_public_path__ + "static/media/golden-star-badge.da17fe8c.svg";